<!-- notification-skeleton.component.html -->

<div class="skeleton-list" role="status" aria-live="polite" aria-busy="true">
  @for (item of skeletonItems; track $index) {
    <article class="notification-skeleton" aria-hidden="true">
      <div class="skeleton-body">
        <div class="skeleton-title-row">
          <div class="skeleton-title-with-icon">
            <div class="skeleton-icon-circle skeleton-block"></div>
            <div class="skeleton-title-lines">
              <div class="skeleton-line skeleton-line--title"></div>
            </div>
          </div>
          <div class="skeleton-dot skeleton-block"></div>
        </div>
        <div class="skeleton-line skeleton-line--text"></div>
        @if (showMeta) {
          <div class="skeleton-line skeleton-line--meta"></div>
        }
      </div>
    </article>
  }
</div>
